angular.module('nv.routes.config', []);
